// @flow
import React from 'react';
import { Helmet } from 'react-helmet';

// Material
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Paper from '@material-ui/core/Paper';

// Custom
import SimpleBreadcrumbs from '../components/ui/SimpleBreadcrumbs';

// Data
const links = [{ name: 'Terms' }];

const useStyles = makeStyles(theme => ({
  page: {
    padding: theme.spacing(3, 2),
  },
  link: {
    textDecoration: 'none !important',
  },
}));

const Terms = () => {
  const classes = useStyles();
  const termsUrl = 'https://www.naexguide.com/terms';

  return (
    <React.Fragment>
      <Helmet>
        <title>Terms | Naexguide</title>
        <meta property="og:url" content={termsUrl} />
        <link rel="canonical" href={termsUrl} />
      </Helmet>
      <Container>
        <SimpleBreadcrumbs links={links} />
        <Paper className={classes.page}>
          <h1>Terms and Conditions ("Terms")</h1>

          <p>Last updated: December 14, 2019</p>

          <p>
            Please read these Terms and Conditions ("Terms", "Terms and
            Conditions") carefully before using the https://www.naexguide.com/
            website (the "Service") operated by Naexguide ("us", "we", or
            "our").
          </p>

          <p>
            Your access to and use of the Service is conditioned on your
            acceptance of and compliance with these Terms. These Terms apply to
            all visitors, users and others who access or use the Service.
          </p>

          <p>
            By accessing or using the Service you agree to be bound by these
            Terms. If you disagree with any part of the terms then you may not
            access the Service.
          </p>

          <h2>Links To Other Web Sites</h2>

          <p>
            Our Service may contain links to third-party web sites or services
            that are not owned or controlled by Naexguide.
          </p>

          <p>
            Naexguide has no control over, and assumes no responsibility for,
            the content, privacy policies, or practices of any third party web
            sites or services. You further acknowledge and agree that Naexguide
            shall not be responsible or liable, directly or indirectly, for any
            damage or loss caused or alleged to be caused by or in connection
            with use of or reliance on any such content, goods or services
            available on or through any such web sites or services.
          </p>

          <p>
            We strongly advise you to read the terms and conditions and privacy
            policies of any third-party web sites or services that you visit.
          </p>

          <h2>Termination</h2>

          <p>
            We may terminate or suspend access to our Service immediately,
            without prior notice or liability, for any reason whatsoever,
            including without limitation if you breach the Terms.
          </p>

          <p>
            All provisions of the Terms which by their nature should survive
            termination shall survive termination, including, without
            limitation, ownership provisions, warranty disclaimers, indemnity
            and limitations of liability.
          </p>

          <h2>Governing Law</h2>

          <p>
            These Terms shall be governed and construed in accordance with the
            laws of Japan, without regard to its conflict of law provisions.
          </p>

          <p>
            Our failure to enforce any right or provision of these Terms will
            not be considered a waiver of those rights. If any provision of
            these Terms is held to be invalid or unenforceable by a court, the
            remaining provisions of these Terms will remain in effect. These
            Terms constitute the entire agreement between us regarding our
            Service, and supersede and replace any prior agreements we might
            have between us regarding the Service.
          </p>

          <h2>Disclaimer</h2>

          <p>
            The information contained on Naexguide website (the "Service") is
            for general information purposes only. Naexguide assumes no
            responsibility for errors or omissions in the contents on the
            Service.
          </p>

          <p>
            In no event shall Naexguide be liable for any special, direct,
            indirect, consequential, or incidental damages or any damages
            whatsoever, whether in an action of contract, negligence or other
            tort, arising out of or in connection with the use of the Service or
            the contents of the Service. Naexguide reserves the right to make
            additions, deletions, or modification to the contents on the Service
            at any time without prior notice.
          </p>

          <p>
            Naexguide does not guarantee that the Service will be secure or
            available at any particular time or location; or that any defects or
            errors will be corrected; or the results of using the Service will
            meet all your expectations. Naexguide will take reasonable effort to
            ensure that the Service will be free of viruses or other harmful
            materials and to correct defects once identified.
          </p>

          <h2>Changes</h2>

          <p>
            We reserve the right, at our sole discretion, to modify or replace
            these Terms at any time. If a revision is material we will try to
            provide at least 30 days notice prior to any new terms taking
            effect. What constitutes a material change will be determined at our
            sole discretion.
          </p>

          <p>
            By continuing to access or use our Service after those revisions
            become effective, you agree to be bound by the revised terms. If you
            do not agree to the new terms, please stop using the Service.
          </p>

          <h2>Contact Us</h2>

          <p>If you have any questions about these Terms, please contact us.</p>
        </Paper>
      </Container>
    </React.Fragment>
  );
};

export default Terms;
